import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  QRCode,
  QRCodeContainer,
  LoadingSpinner,
  LoadingSpinnerContainer,
} from "../StyledComponents/AppStyles";

import {
  LoginCredentialsContainer,
  ArrowLeftIcon,
} from "../StyledComponents/LoginStyles";

export default function CredentialLogin({
  connection,
  createInvitation,
  fetchVerification,
  invitation,
  resetAppState,
  setUserData,
  verifiedCredAttributes,
}) {
  const effectRan = useRef(false);
  const navigate = useNavigate();

  const [attemptReady, setAttemptReady] = useState(false);

  useLayoutEffect(() => {
    if (process.env.NODE_ENV === "development") {
      if (!effectRan.current) {
        effectRan.current = true;
      } else {
        return () => {
          effectRan.current = false;
        };
      }
    }

    resetAppState();
    createInvitation();
  }, []);

  useEffect(() => {
    if (!attemptReady) {
      setAttemptReady(true);
    } else if (
      connection &&
      Object.keys(invitation).length !== 0 &&
      Object.keys(verifiedCredAttributes).length === 0
    ) {
      fetchVerification("BANKING_ACCOUNT");
    } else if (connection && Object.keys(verifiedCredAttributes).length !== 0) {
      setAttemptReady(false);
      setUserData({
        givenName: verifiedCredAttributes.given_names,
        familyName: verifiedCredAttributes.surnames,
        userId: verifiedCredAttributes.username,
        dateOfBirth: verifiedCredAttributes.date_of_birth,
        phoneNumber: verifiedCredAttributes.phone_number,
        email: verifiedCredAttributes.email,
        accountId: verifiedCredAttributes.account_id,
        accountEstablishedDate: verifiedCredAttributes.account_established_date,
      });
      navigate("/account");
    }
  }, [connection, invitation, verifiedCredAttributes]);

  return (
    <LoginCredentialsContainer>
      <h2>Credential Log In</h2>
      <p>
        The Indicio Banking Demo allows customers to log into their accounts
        securely using verifiable credentials.
        <b>Scan the QR code below to begin.</b>
      </p>
      <p>
        Don't have an account?{" "}
        <u onClick={() => navigate("/create-account")}>
          Click here to create one.
        </u>
      </p>
      <span>
        <ArrowLeftIcon />
        <u onClick={() => navigate("/login")}>Log in with a password</u>
      </span>
      <QRCodeContainer>
        {!invitation?.invitation_url || connection ? (
          <LoadingSpinnerContainer>
            <LoadingSpinner />
            <p>Please wait...</p>
          </LoadingSpinnerContainer>
        ) : (
          <QRCode value={invitation.invitation_url} renderAs="svg" />
        )}
      </QRCodeContainer>
    </LoginCredentialsContainer>
  );
}
